import Conviva from '@convivainc/conviva-js-coresdk';

let analytics: { video: Conviva.VideoAnalytics; ad: Conviva.AdAnalytics } | null = null;
let initialized = false;

export function setConvivaInitialized(value: boolean) {
  initialized = value;
}

export function getConvivaAnalyticsSingleton() {
  // Conviva throws "Constants not yet configured" if buildVideoAnalytics/buildAdAnalytics run
  // before Conviva.Analytics.init(). Bail out until initialization has completed.
  if (!initialized) return null;

  if (!analytics) {
    const video = Conviva.Analytics.buildVideoAnalytics();
    const ad = Conviva.Analytics.buildAdAnalytics(video);
    analytics = { ad, video };
  }

  return analytics;
}

export function releaseConvivaAnalyticsSingleton() {
  if (analytics) {
    analytics.video.release();
    analytics.ad.release();
    analytics = null;
  }
}
